<div class="cancel-delivery-modal">
  <div class="cancel-delivery-modal__backdrop"></div>
  <div class="cancel-delivery-modal-container">
    <div class="cancel-delivery-modal-container__content">
      <div class="cancel-delivery-modal-container__content-title">Are you sure you want to cancel this delivery?</div>
      <div class="cancel-delivery-modal-container__content-text" *ngIf="!successResponse  && !errorResponse">You may still be charged by the courier if the delivery has started.</div>
      <div class="cancel-delivery-modal-container__content-success" *ngIf="successResponse">{{successResponse}}</div>
      <div class="cancel-delivery-modal-container__content-error" *ngIf="errorResponse">{{errorResponse}}</div>
    </div>
    <div class="cancel-delivery-modal-container__footer">
      <button class="cancel-delivery-modal-container__footer-button" (click)="cancel()">No, don’t cancel</button>
      <button class="cancel-delivery-modal-container__footer-button" (click)="submit()">Yes, cancel</button>
    </div>
  </div>
</div>
